import React from 'react';

import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseThreatPreventionExceptions from '../../AbstractObjects/GatewayPlan/InnerPages/BaseThreatPreventionExceptions';
import {ObjectTypes} from '../../../../api/consts';

const pageSchema = PlanGetSchema.pages.threatPreventionExceptions;
const pageId = pageSchema.pageId;

function PlanThreatPreventionExceptions({
    planObject,
    setPlanData
}) {
    let pageData = planObject[pageId];
    const planName = planObject[PlanGetSchema.id];

    return (
        <BaseThreatPreventionExceptions
            pageData={pageData}
            setObjectData={setPlanData}
            baseObjectName={planName}
            objectType={ObjectTypes.PLAN}
        />
    );
}

export default PlanThreatPreventionExceptions;